module.exports = __webpack_public_path__ + "img/top@3x.fc8a8dce.png";